import styled, { css, keyframes } from 'styled-components';

const sweep = keyframes`
  0% {
    clip-path: inset(0 100% 0 0%);
  }

  8% {
    clip-path: inset(0 100% 0 0%);
  }

  46% {
    clip-path: inset(0 0% 0 0%);
  }

  62% {
    clip-path: inset(0 0% 0 0%);
  }

  100% {
    clip-path: inset(0 0% 0 100%);
  }
`;

const size = (big?: boolean) => css`
  width: ${big ? '92px' : '44px'};
  height: ${big ? '69px' : '33px'};
`;

export const SBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.themeV3.colors.grey50}80;
`;

export const SLoaderInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SLoaderMessage = styled.p`
  margin-top: 20px;
  text-align: center;
  width: 260px;
`;

export const SPreloader = styled.div<{ $big?: boolean }>`
  position: relative;
  ${(props) => size(props.$big)}

  svg {
    ${(props) => size(props.$big)}

    path {
      fill: ${(props) => props.theme.themeV3.colors.green100};
    }
  }
`;

export const SPreloaderSweep = styled.div<{ $big?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: ${sweep} 2.6s cubic-bezier(0.65, 0, 0.35, 1) infinite;

  svg {
    ${(props) => size(props.$big)}

    path {
      fill: ${(props) => props.theme.themeV3.colors.green300};
    }
  }
`;
